function isScrolledIntoView(item) {
    let windowTop = $(window).scrollTop();
    let windowBottom = windowTop + $(window).height() - $(item).height();
    let itemTop = $(item).offset().top;
    let itemBottom = itemTop + $(item).height();
    return ((itemBottom <= windowBottom) && (itemTop >= windowTop));
}

function scrollSlickItem() {
    $('.isa-slider__list--scroll .isa-slider__list-item').each(function () {
        if(isScrolledIntoView(this) === true) {
            $(this).click();
        }
    });
}

function initEventHandlers() {
    let $isaVerticalScroll = $('.isa-slider__list--scroll');
    let $isaDesktop = $('.isa-slider__desktop');

    $isaDesktop.slick({
        slide: 'li',
        speed: 500,
        slidesToShow: 1,
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.isa-slider__list--scroll',
        rows: 0,
        infinite: false
    });
    $isaVerticalScroll.slick({
        slide: 'li',
        speed: 500,
        slidesToShow: 4,
        rows: 0,
        asNavFor: '.isa-slider__desktop',
        focusOnSelect: true,
        infinite: false,
        dots: false,
        vertical: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    vertical: false
                }
            }
        ]
    });
    $(window).on('scroll', scrollSlickItem);
}
$(function () {
    initEventHandlers();
});
